import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Controller } from 'src/app/core/models/controller.model';
import { Location } from 'src/app/core/models/project/location.model';
import { ApiLocationsService } from 'src/app/shared/services/api-locations.service';
import { LocationsService } from '../../services/locations.service';

@Component({
  selector: 'app-room-modal-service',
  templateUrl: './room-modal-service.component.html',
  styleUrls: ['./room-modal-service.component.scss'],
})
export class RoomModalServiceComponent implements OnInit {
  @Input() controllers: Controller[];
  locations$: Observable<Location[]> = this.locationsService.getLocations();
  selectedLocation: Location;
  selectedController: Controller;

  constructor(
    private locationsService: LocationsService,
    private apiLocationsService: ApiLocationsService,
    private changeDetectionRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.apiLocationsService.getLocations().subscribe();
  }

  selectLocation(locationId: number) {
    this.selectedLocation = null;
    this.selectedController = null;
    this.changeDetectionRef.detectChanges();
    this.locations$.pipe(take(1)).subscribe((locations) => {
      this.selectedLocation = locations.find((loc: Location) => {
        return loc.locationId === locationId;
      });
    });
  }

  selectController(controller: Controller) {
    this.selectedLocation = null;
    this.selectedController = null;
    this.changeDetectionRef.detectChanges();
    this.selectedController = controller;
  }

  cancelSelection() {
    this.selectedLocation = null;
    this.selectedController = null;
  }
}
